// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"e9e3a815","284":"e0468602","453":"0130d51a"}[chunkId] + ".chunk.js";
};